<script lang="ts" setup>import { computed as _computed } from 'vue';

import { type ISOPRO, ISOPROHeight } from '~/models';
import { DataTableModel } from './models';

interface Props {
  model: DataTableModel<ISOPRO>;
  hasShearForceRow: boolean;
  hasVariantRow: boolean;
}

const props = defineProps<Props>();

const fixedHeaderHeight = _computed(() => 64 + (props.hasShearForceRow ? 33 : 0) + (props.hasVariantRow ? 33 : 0) + 'px');
const collectionHasData = (heightCollection: DataTableModel<ISOPRO>[ISOPROHeight]) => {
  const total = Object.values(heightCollection).reduce((len, lbcCollection) => {
    len += Object.values(lbcCollection).reduce((acc, variantCollection) => {
      acc += Object.entries(variantCollection).filter(([key, productArray]) => {
        const assertion = props.hasVariantRow ? key !== 'none' : key === 'none';
        return assertion;
      }).reduce((sum, [key, productArray]) => {
        sum += productArray.length;
        return sum;
      }, 0);
      return acc;
    }, 0);
    return len;
  }, 0);
  return total > 0;
};
</script>

<template>
  <table class="data-table fixed">
    <thead>
      <tr :style="{ height: fixedHeaderHeight }">
        <th>Height</th>
        <th>Fire<br />protection</th>
      </tr>
    </thead>

    <tbody>
      <template
        v-for="(heightCollection, height) in model"
        :key="height"
      >
        <template v-if="collectionHasData(heightCollection)">
        <tr
          v-for="(lbcCollection, fireProtection) in heightCollection"
          :key="fireProtection"
        >
            <th
              v-if="fireProtection === Object.keys(heightCollection)[0]"
              :rowspan="Object.keys(heightCollection).length"
            >
              {{ height }}
            </th>
            <th>{{ fireProtection }}</th>
          </tr>
        </template>
      </template>
    </tbody>
  </table>
</template>

<style lang="scss" scoped>
  .data-table {
    &.fixed {
      margin-bottom: 18px;
    }
  }
</style>
